const QuotePage = () => (
  <div className="container justify-content-center align-items-center pt-5 mt-5">
    <div className="row ">
      <div className="col">
        <h3 className="text-center pt-5 mt-5">
          <q>
            Mathematics has beauty and romance. It’s not a boring place to be,
            the mathematical world. It’s an extraordinary place; it’s worth
            spending time there.
          </q>
        </h3>
      </div>
    </div>
  </div>
);

export default QuotePage;
